// Glimm Shader and Rainbow Sweep Engine for Beautiful UI

export const ACCENTS = {
  red: '#ef4444',
  orange: '#f97316',
  yellow: '#eab308',
  green: '#22c55e',
  cyan: '#06b6d4',
  blue: '#3b82f6',
  purple: '#a855f7',
};

export function accentChain(colors: string[]) {
  return colors;
}

export function createShader(options: {
  canvas: HTMLCanvasElement;
  palette?: string[];
  direction?: string;
  bandTight?: number;
  swellAmount?: number;
}) {
  const canvas = options.canvas;
  const ctx = canvas.getContext('2d');
  let animationFrameId: number | null = null;
  let active = false;
  let startTime = 0;
  let duration = 950;

  function render(time: number) {
    if (!ctx || !active) return;
    const elapsed = time - startTime;
    const progress = Math.min(1, Math.max(0, elapsed / duration));

    const w = canvas.width;
    const h = canvas.height;
    ctx.clearRect(0, 0, w, h);

    if (progress < 1) {
      const gradient = ctx.createLinearGradient(-w + progress * 2.5 * w, 0, progress * 2.5 * w, 0);
      const colors = options.palette || Object.values(ACCENTS);
      
      colors.forEach((color, idx) => {
        gradient.addColorStop(idx / (colors.length - 1), color);
      });

      ctx.save();
      ctx.globalAlpha = Math.sin(progress * Math.PI) * 0.45;
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, w, h);
      ctx.restore();

      animationFrameId = requestAnimationFrame(render);
    } else {
      ctx.clearRect(0, 0, w, h);
      active = false;
    }
  }

  return {
    canvas,
    triggerSweep(dur = 950) {
      if (!ctx) return;
      canvas.width = canvas.parentElement?.clientWidth || 300;
      canvas.height = canvas.parentElement?.clientHeight || 60;
      duration = dur;
      startTime = performance.now();
      active = true;
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(render);
    },
    destroy() {
      active = false;
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    },
  };
}

export function playSweep(shader: ReturnType<typeof createShader> | null, _options?: any) {
  if (shader) {
    shader.triggerSweep(950);
  }
  return {
    done: new Promise<void>((resolve) => setTimeout(resolve, 950)),
  };
}
